import type { DeviceConfiguration } from '../../../data/configuration/types';

import { processForceUpgradeLinks } from './processForceUpgradeLinks';
import { processPersonalListEnums } from './processPersonalListEnums';
import { processUpdateSection } from './processUpdateSection';
import { DeviceConfigurationResponse, DeviceConfigurationParams } from './types';

export function processDeviceConfiguration({ params }: DeviceConfigurationResponse): DeviceConfiguration {
  const { ForcedUpdateURL, UpdateSection, personallist_enums, ...rest } = params;

  const { translationDictionaries } = visitParams(rest);

  return {
    translationDictionaries,
    ...(ForcedUpdateURL && { forceUpgradeLinks: processForceUpgradeLinks(ForcedUpdateURL) }),
    ...(UpdateSection && { forceUpgrade: processUpdateSection(UpdateSection) }),
    ...(personallist_enums && { personalLists: processPersonalListEnums(personallist_enums) }),
  };
}

// Opening ability to inspect various kind of params in one shot
function visitParams(
  rest: Omit<DeviceConfigurationParams, 'ForcedUpdateURL' | 'UpdateSection' | 'personallist_enums'>,
) {
  const keys = Object.keys(rest);
  const translationDictionaries: Record<string, string> = {};

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (!key.includes('dictionary_url')) {
      continue;
    }

    const [, , languageCode] = key.split('_');

    const dictionaryUrl = rest[key] as string | undefined;

    if (dictionaryUrl) {
      translationDictionaries[languageCode] = dictionaryUrl;
    }
  }

  return { translationDictionaries };
}
